import sortBy from 'lodash/sortBy'

export const toDealsChartData = pipelineData =>
  sortBy(pipelineData, ['order']).map(category => ({
    name: category.categoryName.replace(' Opportunity', ''),
    value: category.value,
    count: category.count,
    color: category.categoryColor
  }))
